/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Navsigningout2Inputs */

const en_navsigningout2 = /** @type {(inputs: Navsigningout2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signing out…`)
};

const pt_navsigningout2 = /** @type {(inputs: Navsigningout2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A sair…`)
};

/**
* | output |
* | --- |
* | "Signing out…" |
*
* @param {Navsigningout2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const navsigningout2 = /** @type {((inputs?: Navsigningout2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Navsigningout2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_navsigningout2(inputs)
	return pt_navsigningout2(inputs)
});
export { navsigningout2 as "navSigningOut" }